import React, { Component } from 'react'
/*import GoogleMapsStyles from './GoogleMapsStyles.json'
import MarkerImage from './poi.svg'*/
import './Map.css'

/*import MarkerFarang from './farang.png'
import MarkerGaijin from './gaijin.png'
import MarkerBoulevardSocial from './boulevard-social.png'
import MarkerLevain from './levain.png'*/

class Map extends Component {
/*  componentDidMount() {
    const latLng = {lat: 60.167011, lng: 24.945389}

    const FarangPosition = {lat: 60.171952, lng: 24.931447}
    const GaijinPosition = {lat: 60.165974, lng: 24.942055}
    const BoulevardSocialPosition = GaijinPosition
    const LevainPosition = {lat: 60.159273, lng: 24.936880}

    const map = new window.google.maps.Map(this.refs.map, {
      zoom: 17,
      minZoom: 13,
      maxZoom: 18,
      center: latLng,
      mapTypeId: 'roadmap',
      mapTypeControl: false,
      streetViewControl: false,
      scrollwheel: false,
      styles: GoogleMapsStyles
    });

    const Marker = {
      url: MarkerImage,
      size: new window.google.maps.Size(52,75),
      origin: new window.google.maps.Point(0,0),
      anchor: new window.google.maps.Point(21,75)
    };

    const Farang = {
      url: MarkerFarang,
      size: new window.google.maps.Size(52,52),
      origin: new window.google.maps.Point(0,0),
      anchor: new window.google.maps.Point(21,21)
    };

    const Gaijin = {
      url: MarkerGaijin,
      size: new window.google.maps.Size(52,52),
      origin: new window.google.maps.Point(0,0),
      anchor: new window.google.maps.Point(21,21)
    };

    const BoulevardSocial = {
      url: MarkerBoulevardSocial,
      size: new window.google.maps.Size(52,52),
      origin: new window.google.maps.Point(0,0),
      anchor: new window.google.maps.Point(21,21)
    };

    const Levain = {
      url: MarkerLevain,
      size: new window.google.maps.Size(52,52),
      origin: new window.google.maps.Point(0,0),
      anchor: new window.google.maps.Point(21,21)
    };

    new window.google.maps.Marker({
      position: latLng,
      map: map,
      icon: Marker
    });

    new window.google.maps.Marker({
      position: FarangPosition,
      map: map,
      icon: Farang
    });

    new window.google.maps.Marker({
      position: GaijinPosition,
      map: map,
      icon: Gaijin
    });

    new window.google.maps.Marker({
      position: BoulevardSocialPosition,
      map: map,
      icon: BoulevardSocial
    });

    new window.google.maps.Marker({
      position: LevainPosition,
      map: map,
      icon: Levain
    });

    const center = map.getCenter();

    window.google.maps.event.addListenerOnce(map, 'idle', function() {
      window.google.maps.event.trigger(map, 'resize');
      map.setCenter(center);
    })
    window.google.maps.event.addDomListener(window, 'resize', function() {
      map.setCenter(center);
    })
  }
*/
  render() {
    return (
    	<div className="google-map" ref="map">
          	<div className="map-contributors"><div><a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a> | © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> © <a href="http://cartodb.com/attributions">CartoDB</a></div></div>
        </div>
    )
  }
}

export default Map;



// WEBPACK FOOTER //
// ./src/components/Map/Map.js